// Every tracker this app can load, its on/off switch, and the env vars that feed
// it. A tracker runs only when `enabled` is true AND its required env var is
// set (ad pixels also only in production builds). To see what is on and what
// each tracker receives: `?devmode=true`, then "tracking" in the dev toolbar.
//
// Relative import on purpose: gatsby-config loads this file too. Gatsby bundles
// relative imports into its compiled config, but leaves @base (alias) and
// @neontree/gatsby-base (package) imports for Node, which can't load .ts.
import {
  env,
  TrackersConfig,
} from "../../../packages/gatsby-base/src/lib/tracking-lib/trackers";

export const trackers: TrackersConfig = {
  meta: {
    enabled: true,
    pixelID: env("GATSBY_FB_PIXEL_ID", process.env.GATSBY_FB_PIXEL_ID),
  },
  snap: {
    enabled: false,
    pixelID: env("GATSBY_SNAP_PIXEL_ID", process.env.GATSBY_SNAP_PIXEL_ID),
  },
  bigo: {
    enabled: false,
    pixelID: env("GATSBY_BIGO_PIXEL_ID", process.env.GATSBY_BIGO_PIXEL_ID),
  },
  googleAds: {
    enabled: false,
    conversionID: env("GATSBY_GOOGLE_ADS_ID", process.env.GATSBY_GOOGLE_ADS_ID),
    purchaseLabel: env(
      "GATSBY_GOOGLE_ADS_PURCHASE_LABEL",
      process.env.GATSBY_GOOGLE_ADS_PURCHASE_LABEL,
    ),
  },
  gtm: {
    enabled: true,
    id: env("GATSBY_GTM_ID", process.env.GATSBY_GTM_ID),
    // Loads gtm.js from our own domain via Stape (production sets this in Netlify).
    selfHostedOrigin: env(
      "GATSBY_GTM_SELF_HOSTED_ORIGIN",
      process.env.GATSBY_GTM_SELF_HOSTED_ORIGIN,
    ),
    ga4ServerContainerURL: env(
      "GATSBY_GA4_SERVER_CONTAINER_URL",
      process.env.GATSBY_GA4_SERVER_CONTAINER_URL,
    ),
  },
  posthog: {
    enabled: true,
    key: env("GATSBY_POSTHOG_KEY", process.env.GATSBY_POSTHOG_KEY),
    host: env("GATSBY_POSTHOG_HOST", process.env.GATSBY_POSTHOG_HOST),
  },
  klaviyo: {
    enabled: true,
    key: env("GATSBY_KLAVIYO_KEY", process.env.GATSBY_KLAVIYO_KEY),
  },
  sentry: {
    enabled: true,
    dsn: env("GATSBY_SENTRY_DSN", process.env.GATSBY_SENTRY_DSN),
  },
};
